<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Track Progress</h1>
            <ul>

                <li> <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i> Back</a></li>
            </ul>
        </div>
    </div>
</div>

<div class="el-pricing-wrapper">
    <div class="container">
        <div class="el-pricing-main-parent">
            <div class="row" style="margin-bottom: 50px;" *ngIf="ReportList.length>0">
                <div class="col-md-4">
                    <label>Subject</label>
                    <select class="form-control" [(ngModel)]="Subject" (change)="Subject_Changed()">
                        <option value="All">All</option>
                        <option *ngFor="let _obj of SubjectList" [value]="_obj.subjectName">{{_obj.subjectName}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">


                <div class="d-flex justify-content-center" *ngIf="IsShowMessage">
                    <div class="col-md-5 alert">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"
                            style="font-size: 50px;color: #e04787;"></i>
                        <br><br>

                        <div *ngIf="this.PREP_UserInfo.childId!=null">

                            You have not submitted any mock test for the child <strong>{{this.PREP_UserInfo.childName}}
                            </strong> of  <strong *ngIf="PREP_UserInfo.classId <= '12'">Class {{PREP_UserInfo.classId}}</strong>  <strong *ngIf="PREP_UserInfo.classId > '12'">Class {{PREP_UserInfo.className}}.</strong> 

                            <br><br>
                            <a [routerLink]="['/MyMockTest']" class="el-btn"> Start Mock Test</a>
                        </div>
                        <div *ngIf="this.PREP_UserInfo.childId==null">
                            No child added yet. Kindly add a child to proceed.
                            <br><br>
                            <a (click)="Switch_Child()" class="el-btn"> <strong>Add Child</strong></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6" *ngFor="let exam of ReportList; let i = index"
                    style="margin-bottom: 50px;">
                    <div class="el-price-box">
                        <div class="el-price-inner">
                            <h4 class="el-popular-plan limit-text"> {{exam.subjectName}}</h4>
                            <div class="el-price-head">
                                <div class="el-price-img d-flex justify-content-between align-items-center pb-4">

                                    <h4 class="theme-color">
                                        <a class="el-btn" *ngIf="Get_Question_For_ReSubmit(exam)"
                                            (click)="ReSubmit(exam)"
                                            style="background-color:#f0f0f0;color:#e04787;pointer-events:auto;opacity:0.7 ">
                                            Re-Submit
                                        </a>

                                        <span *ngIf="exam.marks!=null"><small>Obtained Marks</small> <br>
                                            {{exam.marks}}<span class="text-dark">/100</span></span>

                                    </h4>
                                    <img src="../assets/images/all-instructor/rep.png" alt="icon">

                                </div>

                                <a *ngIf="exam.examStatus=='Test submitted'" href="/ProgressReport?id={{exam.id}}"
                                    class="el-btn" style="pointer-events:auto;opacity:1 ">
                                    View Progress Report
                                </a>

                                <a *ngIf="exam.examStatus=='Resume Test'" href="javascript:;" class="el-btn"
                                    (click)="ResumeTest(exam)"
                                    style="background-color:#f0f0f0;color:#e04787;pointer-events:auto;opacity:1 ">
                                    {{exam.examStatus}}
                                </a>
                                <a *ngIf="exam.examStatus=='Test not submitted'" href="javascript:;" class="el-btn"
                                    style="background-color:#ffc107;color:#020101;pointer-events:auto;opacity:1 ">

                                    {{exam.examStatus}}
                                </a>



                            </div>
                            <div class="el-pricing-list">
                                <ul>

                                    <li class="el-para"><i class="fa fa-check-circle"></i>Child Name: <strong>{{
                                            exam.childName}}</strong></li>
                                    <li class="el-para"><i class="fa fa-check-circle"></i>
                                        <span *ngIf="exam.classId <= '12'"> {{ exam.className }}</span> <span
                                            *ngIf="exam.classId > '12'">Class {{ exam.className }}</span>
                                    </li>
                                    <li class="el-para"><i class="fa fa-check-circle"></i>Exam Date: {{ exam.startExam
                                        |
                                        date:'dd-MMM-yyyy HH:mm:ss a'}}</li>
                                    <!-- <li class="el-para"><i class="fa fa-check-circle"></i>End Exam: {{ exam.endExam
                                        |
                                        date:'dd-MMM-yyyy HH:mm:ss a'}}</li> -->
                                    <!-- <li class="el-para"><i
                                            class="fa fa-check-circle"></i>{{exam.durationMinutes>0?exam.durationMinutes+'
                                        Minutes':'-'}} </li> -->



                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="table-responsive">
                <table class="styled-table">
                    <thead>
                        <tr>
                            <th>Sr No</th>
                            <th>Plan</th>
                            <th>Subject</th>
                            <th>Class</th>
                            <th>Financial Year</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Duration</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let exam of ReportList; let i = index">
                            <td>{{ i + 1 }}</td>

                            <td>{{ exam.planId ==0 ? "Mock": exam.planId}}</td>
                            <td>{{ exam.subjectName }}</td>


                            <td>{{ exam.className }}</td>
                            <td>{{ exam.fYear }}</td>
                            <td>{{ exam.startExam | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            <td>{{ exam.endExam | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            <td>{{ exam.durationMinutes || '-' }} min</td>
                            <th><span style="cursor: pointer;" (click)="onView(exam.id)">View</span></th>

                        </tr>
                    </tbody>
                </table>
            </div> -->
        </div>
    </div>
</div>